"use strict";

var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./product/detail"));
    processInclude(require("./product/wishlistHeart"));
    // DGF-3054 — express wallets. A no-op unless the server rendered the PDP express container,
    // so it costs nothing when the preference is off.
    processInclude(require("./product/expressPayments"));
});
